import { render, staticRenderFns } from "./ChartComponent.vue?vue&type=template&id=012c5e36"
import script from "./ChartComponent.vue?vue&type=script&lang=js"
export * from "./ChartComponent.vue?vue&type=script&lang=js"
import style0 from "./ChartComponent.vue?vue&type=style&index=0&id=012c5e36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports